(function () {
  const CACHE_KEY = 'laguna_search_index_v4';
  const CACHE_TTL_MS = 60 * 60 * 1000;
  const INDEX_URL = '/collections/todos-os-produtos?view=search-index';
  const PAGE_BATCH = 5;
  const MIN_QUERY_LENGTH = 2;
  const MAX_RESULTS = 250;
  const DIACRITICS = /\p{Diacritic}/gu;

  let loadPromise = null;
  let facetsMeta = [];

  const normalize = (value) =>
    (value || '').toLowerCase().normalize('NFD').replace(DIACRITICS, '');

  const decorate = (items) => {
    items.forEach((item) => {
      item._title = normalize(item.t);
      item._skus = (item.sku || []).map(normalize);
      item._ty = normalize(item.ty);
      item._sz = (item.sz || []).map((v) => String(v).toUpperCase());
      item._mf = {};
      const mf = item.mf || {};
      Object.keys(mf).forEach((param) => {
        item._mf[param] = JSON.stringify(mf[param] == null ? '' : mf[param]).toLowerCase();
      });
    });
    return items;
  };

  function readCache() {
    try {
      return JSON.parse(localStorage.getItem(CACHE_KEY));
    } catch (error) {
      return null;
    }
  }

  function writeCache(count, items, facets) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), count, items, facets }));
    } catch (error) {
      return;
    }
  }

  async function fetchPage(page) {
    const response = await fetch(`${INDEX_URL}&page=${page}`);
    if (!response.ok) throw new Error(`search-index page ${page}: HTTP ${response.status}`);

    const text = await response.text();
    let data;
    try {
      data = JSON.parse(text);
    } catch (error) {
      throw new Error(`search-index page ${page}: resposta não é JSON -> ${text.slice(0, 150)}`);
    }
    if (!Array.isArray(data.items)) {
      throw new Error(`search-index page ${page}: sem "items" -> ${text.slice(0, 150)}`);
    }
    return data;
  }

  async function build() {
    const first = await fetchPage(1);

    const cached = readCache();
    if (cached && cached.count === first.count && Date.now() - cached.ts < CACHE_TTL_MS) {
      facetsMeta = cached.facets || [];
      return decorate(cached.items);
    }

    facetsMeta = first.facets || [];
    let items = first.items;
    for (let page = 2; page <= first.pages; page += PAGE_BATCH) {
      const batch = [];
      for (let i = page; i < page + PAGE_BATCH && i <= first.pages; i += 1) {
        batch.push(fetchPage(i));
      }
      const results = await Promise.all(batch);
      results.forEach((result) => {
        items = items.concat(result.items);
      });
    }

    writeCache(first.count, items, facetsMeta);
    return decorate(items);
  }

  function load() {
    if (!loadPromise) {
      loadPromise = build().catch((error) => {
        loadPromise = null;
        throw error;
      });
    }
    return loadPromise;
  }

  function rank(item, query) {
    let score = 0;
    if (item._title.startsWith(query)) score += 4;
    else if (item._title.includes(query)) score += 2;
    if (item._skus.some((sku) => sku.startsWith(query))) score += 5;
    else if (item._skus.some((sku) => sku.includes(query))) score += 3;
    return score;
  }

  async function match(query, includeUnavailable) {
    const normalized = normalize((query || '').trim());
    if (normalized.length < MIN_QUERY_LENGTH) return [];

    const items = await load();
    const hits = [];
    for (const item of items) {
      if (!includeUnavailable && item.a === false) continue;
      if (item._title.includes(normalized) || item._skus.some((sku) => sku.includes(normalized))) {
        hits.push(item);
      }
    }
    hits.sort((a, b) => rank(b, normalized) - rank(a, normalized));
    return hits;
  }

  async function search(query, limit = 6, includeUnavailable = false) {
    return (await match(query, includeUnavailable)).slice(0, limit);
  }

  async function searchAll(query, includeUnavailable = false) {
    return (await match(query, includeUnavailable)).slice(0, MAX_RESULTS);
  }

  function getFacetsMeta() {
    return facetsMeta;
  }

  window.lagunaSearchIndex = { load, search, searchAll, getFacetsMeta };

  const conn = navigator.connection;
  if (!conn || (!conn.saveData && !/(^|-)2g$/.test(conn.effectiveType || ''))) {
    const scheduleIdle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1500));
    scheduleIdle(() => load().catch(() => {}));
  }
})();
